(ns teamoesterreich.admin-mode.text-blocks.text-block-list
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.text-blocks.create-with-name-and-type-modal :as create-with-name-and-type-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.text-blocks.text-block-trigger-helper :as trigger-helper]

            [reagent-material-ui.icons.add :refer [add]]

            [teamoesterreich.admin-mode.data.text-block :as d-text-block]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.lock :refer [lock]]

            ))

(def *do-log
  log/debug
  )

(defn get-type [key]
  (or (get {:email "Email"
            :md    "Formatierter Text"
            :sms   "SMS"}
           key) (str "?" key)))


(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        l-date (if (> cell-data 893462400000)
                 (h-date/print-google-date (h-date/parse-unix-date cell-data))
                 "-")
        ]
    (*do-log l-date)
    (r/as-element
      [:span l-date])))
(defn org-cell-renderer [dep-mask-list dst-mask-list]
  (fn [js-parm]
    (let [{orgId "cellData"} (js->clj js-parm)
          orgId (or orgId "XXXX")
          dep (or (get dep-mask-list orgId)
                  (reduce (fn [c [m n]] (if (re-find (re-pattern m) (str orgId)) n c)) "-" dep-mask-list))
          dest (or (get dst-mask-list orgId) "-")]
      (r/as-element
        [:span {:data-mask orgId} dep " " dest]))))
(defn trigger-cell-renderer [trigger-names]
  (fn [js-parm]
    (let [{trigger-key "cellData"} (js->clj js-parm)]
      (r/as-element
        [:span {:data-trigger trigger-key} "" (or (get trigger-names (keyword trigger-key)) (str ":" trigger-key))]
        ))))



(defn edit-cell-renderer [!selected]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        (if (d-rights/is-superuser?)
          [mui/icon-button {:label   "bearbeiten"
                            :onClick (fn []
                                       (reset! !selected cell-data)
                                       (a/set-page :textBlock-edit))
                            } [edit {:fontSize "small"}]]

          [mui/icon-button {:label   "details"
                            :onClick (fn []
                                       (reset! !selected cell-data)
                                       (a/set-page :textBlock-edit))
                            } [info {:fontSize "small"}]])))))


(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !show-inactive (r/cursor !st [:show-inactive])
          !selected (r/cursor v-state/app-state [:textBlock-list :selected])
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !groups (r/cursor !st [:groups])


          !organisations (r/cursor v-state/app-state [:organisations])
          dep-mask-list (or (d-organisation/get-lv-filter-list @!organisations) [])
          dst-mask-list (or (d-organisation/get-dest-list @!organisations) [])
          trigger-names (trigger-helper/get-trigger->name)
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 50)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       65
          :width           width
          :headerClassName "headerColumn"
          :className       "TextBlockList"}


         [:> rv/Column
          {:label        "#"
           :dataKey      (name :toeTextBlock-uuid)
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !selected)
           :width        70}]

         [:> rv/Column
          {:label        "Gruppe"
           :dataKey      (name :toeTextBlock-group)
           :className    "bordered exampleColumn"
           :cellRenderer (fn [js-parm] (let [{cell-data "cellData"} (js->clj js-parm)] (get @!groups cell-data)))
           :style        {:overflow "hidden" :textAlign "left"}
           :width        120}]

         [:> rv/Column
          {:label        "Trigger"
           :dataKey      (name :toeTextBlock-key)
           :className    "bordered exampleColumn"
           :cellRenderer (trigger-cell-renderer trigger-names)
           :style        {:overflow "hidden" :textAlign "left"}
           :width        150}]

         [:> rv/Column
          {:label        "Typ"
           :dataKey      (name :toeTextBlock-type)
           :className    "bordered exampleColumn"
           :cellRenderer (fn [js-parm] (let [{cell-data "cellData"} (js->clj js-parm)] (get-type (keyword cell-data))))
           :style        {:overflow "hidden" :textAlign "left"}
           :width        100}]

         [:> rv/Column
          {:label     "Name"
           :dataKey   (name :toeTextBlock-name)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden" :textAlign "left"}
           :width     200}]


         [:> rv/Column
          {:label        "OrgFilter"
           :dataKey      (name :toeTextBlock-orgIdFilter)
           :cellRenderer (org-cell-renderer dep-mask-list dst-mask-list)
           :className    "bordered exampleColumn"
           :style        {:overflow "hidden"}
           :width        120}]

         [:> rv/Column
          {:label        (r/as-element [lock])
           :dataKey      (name :toeTextBlock-locked)
           :cellRenderer (fn [js-parm] (let [{cell-data "cellData"} (js->clj js-parm)]
                                         (r/as-element (if (true? (or cell-data false)) [lock] [:span ""]))))
           :className    "bordered exampleColumn"
           :width        50}]

         (when @!show-inactive
           [:> rv/Column
            {:label        "gelöscht"
             :dataKey      (name :toeTextBlock-active)
             :cellRenderer (fn [js-parm]
                             (let [{cell-data "cellData"} (js->clj js-parm)] (if (false? cell-data) "X" "")))
             :className    "bordered exampleColumn"
             :width        50}])

         [:> rv/Column
          {:label        "Text"
           :dataKey      (name :toeTextBlock-content)
           :className    "bordered exampleColumn"
           :cellRenderer (fn [js-parm] (let [{row-data "rowData"} (js->clj js-parm)]
                                         (r/as-element [:span (when-let [c (get row-data "toeTextBlock-subject")] [:div {:style {:color "blue"}} c])
                                                        (get row-data "toeTextBlock-content")])))
           :style        {:overflow "hidden" :textAlign "left"}
           :width        420}]

         ]))))


(defn filter-fn [rows {:keys [show-inactive group_ sort_ reverse_ org-filter]}]
  (*do-log "filter-fn " (clj->js sort_) (clj->js rows) (clj->js group_) (clj->js org-filter))
  (let [list (mapv (fn [[k v]] v)
                   (filter (fn [[k v]]
                             (and
                               (or show-inactive (not (false? (:toeTextBlock-active v))))
                               (org-selector/check-org-id (:toeTextBlock-orgIdFilter v) org-filter)
                               (or (nil? group_) (= group_ "") (= group_ (:toeTextBlock-group v)))
                               )) rows))
        list (if sort_ (sort-by (keyword sort_) list) list)
        list (if reverse_ (reverse list) list)
        ]
    list))

(defn update-list [!st]
  (let [!loaded? (r/cursor !st [:loaded])
        !data (r/cursor !st [:data])
        !group (r/cursor v-state/app-state [:textBlock-list :selectedGroup])
        !show-inactive (r/cursor !st [:show-inactive])
        !sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:reverse])
        !org-filter (r/cursor !st [:org-filter])]
    (if-not @!loaded?
      (d-text-block/get-text-groups
        (fn [groups]
          (d-text-block/get-text-blocks
            (fn [data]
              (let [r-data (filter-fn data {:show-inactive @!show-inactive :group_ @!group :sort_ @!sort :reverse_ @!reverse :org-filter @!org-filter})]
                (swap! !st assoc
                       :data data
                       :groups groups
                       :loaded true
                       :count (count r-data)
                       :rows r-data))))))
      (let [r-data (filter-fn @!data {:show-inactive @!show-inactive :group_ @!group :sort_ @!sort :reverse_ @!reverse :org-filter @!org-filter})]
        (swap! !st assoc
               :count (count r-data)
               :rows r-data
               ))
      )))



(defn get-table [!st !rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "400px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st @!rows)]))


(defn get-it []
  (let [!st (r/atom {:data {} :rows [] :group "admin" :loaded nil :create-modal-show nil})]
    (fn []
      (let [!create-modal (r/cursor !st [:create-modal-show])
            !selected (r/cursor v-state/app-state [:textBlock-list :selected])
            !org-filter (r/cursor !st [:org-filter])
            !show-inactive (r/cursor !st [:show-inactive])
            !loaded? (r/cursor !st [:loaded])
            !rows (r/cursor !st [:rows])
            !group (r/cursor v-state/app-state [:textBlock-list :selectedGroup])
            !groups (r/cursor !st [:groups])
            ]
        (*do-log "Mount list " (clj->js @!groups) (clj->js @!rows))

        (when (and @!loaded? (not @!group))
          (reset! !group (ffirst @!groups))
          )
        (update-list !st)
        [mui/paper {:style {:marginTop "10px"}}

         [mui/grid
          {:container  true
           :direction  "row"
           :alignItems "stretch"
           :justify    "flex-start"
           :spacing    1
           :style      {:marginTop "15px" :height "100%" :minHeight "400px"}
           }
          [mui/grid
           {:item true
            :lg   10
            :md   10
            :xs   10
            :type {:textAlign "bottom"}
            }
           [mui/typography {:variant "h5" :padding "5px 0 0 0"}
            " Vorlagen Liste "]
           ]
          [mui/grid
           {:item true
            :lg   2
            :md   3
            :xs   6
            }
           [ws-event-sync-component/ws-event-reload !loaded? :warning]
           ]
          [create-with-name-and-type-modal/modal !create-modal
           (fn [new-name new-type]
             (d-text-block/add-new @!group new-name new-type
                                   (fn [d-textBlock]
                                     (*do-log "## text-block/add-new " (:toeTextBlock-uuid d-textBlock))
                                     (reset! !loaded? false)
                                     (reset! !selected (:toeTextBlock-uuid d-textBlock))
                                     (a/set-page :textBlock-edit)
                                     )))]
          (when (not (empty? @!groups))
            [mui/grid
             {:item true
              :lg   2
              :md   3
              :xs   6}
             [mui/form-control
              {:fullWidth true}
              [mui/input-label "Vorlagen Gruppe"]
              [mui/select
               {:fullWidth true
                :value     (or @!group "")
                :onChange  (fn [e] (reset! !group (h/event-value e)))
                :label     "Vorlagen Typ"}
               (for [[group group-name] @!groups]
                 ^{:key (str "textBlockGroup-" group)}
                 [mui/menu-item {:value group} group-name])
               ]]])

          [mui/grid
           {:item true
            :md   4
            :xs   6
            }
           [org-selector/get-selector !org-filter (fn []) (d-rights/get-rights-orgId-filter d-rights/CONTENT)]
           ]



          (when-not (or (= @!group "") (nil? @!group))
            [mui/grid
             {:item true
              :lg   2
              :md   3
              :xs   6
              }
             [mui/button {:startIcon (r/as-element [add]) :color "secondary" :variant "outlined" :style {:margin "5px 40px 5px 0"}
                          :onClick   #(reset! !create-modal true)
                          }
              "Neue Vorlage"]
             ]
            )

          [mui/grid
           {:item true
            :lg   3
            :md   3
            :xs   4
            }
           [mui/radio-group {:row true :class "filterRadio" :style {:marginLeft "15px"}}
            [mui/form-control-label {:label   "Nicht aktive einblenden" :value "dst" :placement "start"
                                     :control (r/as-element [mui/checkbox {:checked  (or @!show-inactive false)
                                                                           :onChange (fn [_ val] (reset! !show-inactive val))
                                                                           }])}]]]


          [mui/grid
           {:item true
            :xs   12
            }
           [get-table !st !rows]
           ]
          ]

         ]))
    ))




